import React, { FC, useCallback, useEffect, useState } from 'react';

import { useApi, useFetchData } from '@app/hooks';

import { Table } from '../../common/table/table';
import { useColumns } from './columns';
import { VarFormInstance } from './types';
import { useEntitiesState } from '../../../hooks/use-entities-state';
import EditVar from './edit';

const VarsTable: FC = () => {
  const api = useApi();

  const [vars, total, loading, setState] = useEntitiesState<VarFormInstance>();
  const [editOpen, setEditOpen] = useState(false);
  const [operatedVar, setOperatedVar] = useState<VarFormInstance>();

  const fetchData = useCallback(async () => {
    setState([], 0, true);
    const result = await api.service.getVars();
    setState(result.data || [], result.data?.length || 0, false);
  }, [api.service, setState]);

  const columns = useColumns({
    onEdit: (id: string) => {
      setOperatedVar(vars.find((item) => item.id === id));
      setEditOpen(true);
    },
    onRemove: async (id: string) => {
      await api.service.removeVar(id);
      fetchData();
    },
  });

  useEffect(() => {
    if (!editOpen) {
      fetchData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editOpen]);

  return (
    <>
      <Table
        title="Переменные"
        data={vars}
        columns={columns}
        onCreateClick={() => {
          setOperatedVar(undefined);
          setEditOpen(true);
        }}
        loading={loading}
      />
      <EditVar open={editOpen} setOpen={setEditOpen} variable={operatedVar} />
    </>
  );
};

export default VarsTable;
